import styles from './BuyCreatorPlanAndUploadPlan.module.scss';
import { RECURRING_INTERVAL } from './subscriptionHelper';

export const CycleToggle = ({ cycle, setCycle }) => {
  return (
    <div className={styles.toggle}>
      <button
        onClick={() => setCycle(RECURRING_INTERVAL.MONTH)}
        className={`${styles.toggleButton} ${cycle === RECURRING_INTERVAL.MONTH && styles.active}`}>
        Monthly
      </button>
      <button
        onClick={() => setCycle(RECURRING_INTERVAL.YEAR)}
        className={`${styles.toggleButton} ${cycle === RECURRING_INTERVAL.YEAR && styles.active}`}>
        Yearly (2 months free)
      </button>
    </div>
  );
};
